import { render, staticRenderFns } from "./slug.vue?vue&type=template&id=4ea4ad0b&scoped=true&"
import script from "./slug.vue?vue&type=script&lang=js&"
export * from "./slug.vue?vue&type=script&lang=js&"
import style0 from "./slug.vue?vue&type=style&index=0&id=4ea4ad0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4ad0b",
  null
  
)

export default component.exports